module.exports = __webpack_public_path__ + "img/veg.7328d7ef.png";